export * from './StrapiFeaturedArticles';
export { default as StrapiFeaturedArticles } from './StrapiFeaturedArticles';
